<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Consolidado por</label>
                    <el-select v-model="filtro.consolidado" @change="changeConsolidado">
                        <el-option key="atividades" label="ATIVIDADES" value="atividades"></el-option>
                        <el-option key="periodo" label="PERÍODO" value="periodo"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <c-panel v-if="filtro.consolidado" class="u-mt-10">
            <el-form ref="form" :model="filtro" label-position="top">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição" key="instituicao" v-if="[4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo))">
                            <el-select @change="initForm()" ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number($store.state.user.tipo))">
                            <label>Instituição</label>
                            <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma_id" key="turma_id" :rules="[{required: true, message: 'Campo obrigatório.', trigger: 'change'}]">
                            <el-select @change="changeTurma()" v-model="filtro.turma_id" filterable placeholder="Selecione">
                                <el-option
                                    v-for="turma in dados.turmas"
                                    :key="turma.id"
                                    :label="`${turma.curso.nome} ${turma.nome}`"
                                    :value="turma.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="filtro.consolidado == 'atividades'">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Período" prop="periodo_diario" key="periodo_diario" :rules="[{required: true, message: 'Campo obrigatório.', trigger: 'change'}]">
                            <el-select v-model="filtro.periodo_diario" placeholder="Selecione">
                                <el-option
                                    v-for="(periodo, i) in turmaSelecionada.periodos_diario"
                                    :key="i"
                                    :label="periodo"
                                    :value="i + 1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Disciplina" prop="disciplina" key="disciplina" :rules="[{required: true, message: 'Campo obrigatório.', trigger: 'change'}]">
                            <el-select v-model="filtro.disciplina" filterable placeholder="Selecione">
                                <el-option
                                    v-for="disciplina in dados.disciplinas"
                                    :key="disciplina.id"
                                    :label="disciplina.nome_area"
                                    :value="disciplina.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button :loading="loading" @click="gerarRelatorio()" type="primary">GERAR RELATÓRIO</el-button>
                    </el-col>
                </el-row>

            </el-form>
        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        loading: false,
        dados: {},
        turmaSelecionada: {},
        filtro: {
            consolidado: '',
            instituicao_id: '',
            turma_id: '',
            periodo_diario: '',
            disciplina: ''
        }
    }),
    mounted () {

        if([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            this.initForm();
        }
    },
    methods: {

        changeConsolidado(){

            this.filtro.periodo_diario = '';
        },
        initForm(){

            this.dados = {};
            this.turmaSelecionada = {};
            this.filtro.turma_id = '';
            this.filtro.periodo_diario = '';
            this.filtro.disciplina = '';

            if(!this.filtro.instituicao_id){
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/nota/initFormNotas/${this.filtro.instituicao_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        changeTurma(){

            this.filtro.periodo_diario = '';
            this.turmaSelecionada = {};

            for(let i in this.dados.turmas){
                if(this.dados.turmas[i].id == this.filtro.turma_id){
                    this.turmaSelecionada = this.dados.turmas[i];
                }
            }
        },
        gerarRelatorio(){

            this.$refs.form.validate((valid) => {

                if(!valid){
                    return false;
                }

                this.loading = true;

                let payload = {
                    turma_id: this.filtro.turma_id,
                    periodo_diario: this.filtro.periodo_diario,
                    disciplina: this.filtro.disciplina,
                    consolidado: this.filtro.consolidado
                };

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioDiarioNota`, payload, this.$store.getters.getHeaderAuthExcel).then(response => {

                    this.loading = false;

                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);

                    const novaAba = window.open(url, '_blank');

                    if(!novaAba){
                        window.location.href = url;
                    }

                }).catch((error) => { this.loading = false; this.$store.commit('throwException', error); });
            });
        }
    }
}
</script>
